import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import SuccessCancellationModal from "../../DoctorDashboard/success-cancellation-modal";
import {
  disableHelpButton,
  enableHelpButton,
} from "../DisableHelpButton/DisableHelpButton";
import Loader from "../../UI Component/Loader/Loader";
import {
  CANCEL_CONFIRM,
  CANCEL_REQUEST,
} from "./CancelAppointmentApiHandler/apiConstants";
import CommonPopup from "../CommonPopup";
import cancel_calendar from "../../../assets/cancel_calendar.svg";
import { REASONS_LIST } from "../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";
import "./cancelAppointmentPopup.scss";
import C2CMiddlePopup from "../Popups/C2CMiddlePopup";
import infoWhite from "../../../assets/info-white.svg";

const CancelAppointmentPopup = (props) => {
  const {
    openCancellationPopup,
    appointment_id,
    doctorId,
    handleClosePopup,
    refreshAppointmentsMethod,
    callNextAppointmentWidget,
    appointment,
    handleEditRaiseInvoice,
  } = props;

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  const [cancellationMessage, setCancellationMessage] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [cancellationOptions, setCancellationOptions] = useState(
    JSON.parse(JSON.stringify(REASONS_LIST))
  );
  const [showTextArea, setShowTextArea] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [confirmCancelModalFlag, setConfirmCancelModalFlag] = useState(false);

  // Lifecycle Methods ===>

  useEffect(() => {
    if (openCancellationPopup) {
      disableHelpButton();
      setPageLoader(true);
      cancelAppointment();
    }
    return () => {
      enableHelpButton();
    };
  }, [openCancellationPopup]);

  // <===

  // API Calls ===>

  const cancelAppointment = () => {
    let params = {
      appointment_id: appointment_id,
      doctor_id: doctorId ? doctorId : userId,
      reason: "Testing",
    };
    if (staffId) {
      params["staff_id"] = staffId;
    }

    let resData = c2cPostApiHandler(CANCEL_REQUEST, params);

    resData.then(([res, err]) => {
      setPageLoader(false);
      if (!err) {
        if (res.status == 200) {
          if (res.data.statusCode === 200) {
            setCancellationMessage(res.data.message);
          } else {
            swal({
              title: "Unable to cancel appointment",
              text: res.data.message,
              icon: "IN",
              button: "Okay",
            });
          }
        }
      } else {
        swal({
          title: "Something went wrong",
          icon: "error",
          button: "Okay",
        });
      }
    });
  };

  const handleConfirmCancel = () => {
    setPageLoader(true);
    handleClosePopup();
    let params = {
      appointment_id: appointment_id,
      doctor_id: doctorId ? doctorId : userId,
      action_reason:
        cancellationReason?.trim() !== ""
          ? cancellationReason
          : cancellationOptions.filter((ele) => ele.selected)[0]
          ? "Other"
          : "",
    };
    if (staffId) {
      params["staff_id"] = staffId;
    }

    let resData = c2cPostApiHandler(CANCEL_CONFIRM, params);

    resData.then(([res, err]) => {
      setPageLoader(false);
      if (!err) {
        if (res.status == 200) {
          if (res.data.statusCode === 200) {
            setShowSuccessModal(true);
          } else {
            swal({
              title: "Unable to cancel appointment",
              text: res.data.message,
              icon: "warning",
              button: "Okay",
            });
          }
        }
      } else {
        swal({
          title: "Unable to cancel appointment",
          icon: "warning",
          button: "Okay",
        });
      }
    });
  };

  const handleConfirmCancelModalRightBtn = () => {
    setConfirmCancelModalFlag(false);
    handleConfirmCancel();
  };

  const handleConfirmCancelModalLeftBtn = () => {
    setConfirmCancelModalFlag(false);
    handleEditRaiseInvoice(appointment);
  };
  // <===

  // Actions ===>

  const handleCancelAppointment = () => {
    if (
      appointment?.appointment_journey_time?.invoice_raised?.invoice_raised_time
    ) {
      handleClosePopup();
      setConfirmCancelModalFlag(true);
    } else {
      handleConfirmCancel();
    }
  };

  const handleCloseModal = () => {
    setCancellationOptions(JSON.parse(JSON.stringify(REASONS_LIST)));
    setShowTextArea(false);
    setCancellationReason("");
    handleClosePopup();
  };

  const handleOnChangeInput = (e) => {
    if (e.target.value.length <= 300) {
      setCancellationReason(e.target.value);
    }
  };

  const handleDropdownSelection = (item) => {
    let ind = cancellationOptions.findIndex((ele) => ele.label === item.label);
    let reason = "";
    cancellationOptions.forEach((ele) => (ele.selected = false));
    cancellationOptions[ind].selected = true;
    reason = cancellationOptions[ind].label;

    if (cancellationOptions[ind].label === "Other") {
      setShowTextArea(true);
      reason = "";
    } else {
      setShowTextArea(false);
    }

    setCancellationReason(reason);
    setCancellationOptions([...cancellationOptions]);
  };

  // <===

  // Helper Methods ===>

  const getRefundAmount = () => {
    if (cancellationMessage == false) return null;
    return cancellationMessage
      .toString()
      .split("Rs.")[1]
      .toString()
      .split(",")[0]
      ?.trim();
  };

  const getSubtitle = () => {
    return (
      <>
        {cancellationMessage !=
        "Do you really want to cancel an appointment?" ? (
          <div>
            On cancellation, your patient will be
            {window.innerWidth < 768 && <br />} refunded Rs.
            {getRefundAmount()} Amount will be{" "}
            {window.innerWidth > 768 && <br />}
            refunded{window.innerWidth < 768 && <br />} only if you cancel 3
            hours before the{window.innerWidth < 768 && <br />} consultation. In
            case of {window.innerWidth > 768 && <br />}
            any query, please{window.innerWidth < 768 && <br />} contact our
            team at <span style={{ color: "#f969a4" }}>1800 267 9899.</span>
          </div>
        ) : (
          <div>
            Can you tell us more why you are <br />
            cancelling this Appointment
          </div>
        )}
      </>
    );
  };

  const getTitle = () => {
    return (
      <span>
        Do you really want to cancel
        <br /> the Appointment?
      </span>
    );
  };

  const getSelectedValue = () => {
    let value = cancellationOptions.filter((ele) => ele.selected)[0];
    return (
      <span style={{ color: value ? "" : "#A3A3A3" }}>
        {value ? value.label : "Cancellation Reason"}
      </span>
    );
  };

  const getErrorMsg = () => {
    return (
      <span
        style={{
          color: 300 - cancellationReason.length === 0 ? "#da1346" : "",
        }}
      >
        {"Characters left : " + (300 - cancellationReason.length) + " of 300"}
      </span>
    );
  };

  const getConfirmCancelModalMsg = () => {
    return (
      <div className="ccm-msg">
        Payment has been received for this appointment. You may proceed with the
        cancellation, but please process the refund separately to avoid it being
        reflected in the day’s collection summary
      </div>
    );
  };
  // <===

  // Display UI ===>

  const displayConfirmCancelModal = () => {
    return (
      confirmCancelModalFlag && (
        <C2CMiddlePopup
          openPopup={confirmCancelModalFlag}
          titleImg={infoWhite}
          subtitle={getConfirmCancelModalMsg()}
          handleClosePopup={() => {
            setConfirmCancelModalFlag(false);
          }}
          leftBtn={"Edit Invoice"}
          hideCloseText={true}
          rightBtn={"Confirm"}
          rightBtnVariant="primary"
          leftBtnVariant="secondary"
          dialogClassName={"cap-confirm-appointment-popup"}
          handleLeftBtnClick={handleConfirmCancelModalLeftBtn}
          handleRightBtnClick={handleConfirmCancelModalRightBtn}
        />
      )
    );
  };
  const displayCancelModal = () => {
    return (
      openCancellationPopup && (
        <CommonPopup
          openPopup={openCancellationPopup}
          titleImg={cancel_calendar}
          title={getTitle()}
          subtitle={getSubtitle()}
          dropdown={true}
          options={cancellationOptions}
          selectedValue={getSelectedValue()}
          showTextArea={showTextArea}
          inputPlaceholder="Enter your reason here"
          inputValue={cancellationReason}
          errorMsg={getErrorMsg()}
          containerStyle={{
            padding:
              cancellationMessage !=
                "Do you really want to cancel an appointment?" &&
              window.innerWidth > 768
                ? "0 8px"
                : "",
          }}
          handleClosePopup={handleCloseModal}
          handleDropdownSelection={handleDropdownSelection}
          handleLeftBtnClick={handleCancelAppointment}
          handleRightBtnClick={handleCloseModal}
          handleOnChangeInput={handleOnChangeInput}
        />
      )
    );
  };

  // <===

  return (
    <div className="cancel-appointment-popup">
      {pageLoader ? (
        <Loader />
      ) : (
        <>
          {displayCancelModal()}
          {displayConfirmCancelModal()}
          <SuccessCancellationModal
            show={showSuccessModal}
            reason={
              cancellationReason?.trim() !== ""
                ? cancellationReason
                : cancellationOptions.filter((ele) => ele.selected)[0]
                ? "Other"
                : ""
            }
            handleClose={() => {
              handleCloseModal();
              setShowSuccessModal(false);
              callNextAppointmentWidget && callNextAppointmentWidget();
              refreshAppointmentsMethod();
            }}
          />
        </>
      )}
    </div>
  );
};

export default CancelAppointmentPopup;
